import React, { useEffect, useRef } from "react";
import PrivacyIcons from "./PrivacyIcons";

// 六大隱私特性網格元件 - 以卡片形式展示核心賣點（帶滾動動畫）
const PrivacyGrid = ({ t }) => {
  const gridRef = useRef(null);

  useEffect(() => {
    const el = gridRef.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add("revealed");
          observer.unobserve(el);
        }
      },
      { threshold: 0.1 }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="privacy-grid" id="privacy" ref={gridRef}>
      <div className="container">
        <div className="grid">
          {t.privacyFeatures.map((feature, index) => {
            const Icon = PrivacyIcons[index];
            return (
              <div
                className="grid-card grid-card-anim"
                key={index}
                style={{ transitionDelay: `${index * 0.1}s` }}
              >
                <span className="icon">
                  {Icon ? <Icon /> : feature.icon}
                </span>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PrivacyGrid;
